// extracted by mini-css-extract-plugin
export default {"wrapper__title":"Settings_wrapper__title__9pywh","wrapper__tabContainer":"Settings_wrapper__tabContainer__V97Kp"};